import { Environments } from '@/config';
import { WELLSPAN_PRODUCTION } from './wellspan.production';
import { WELLSPAN_STAGING } from './wellspan.staging';

export const WELLSPAN = import.meta.env.MODE === Environments.PROD ? WELLSPAN_PRODUCTION : WELLSPAN_STAGING;
